import Component from '../abstracts/Component';
import ScrollMagic from 'scrollmagic';
import 'debug.addIndicators';

export default class ShopTheLookComponent extends Component {

  get SELECTORS() {
    return {
      container: '.c-shop-the-look',
      backdropMobile: '.js-backdrop-stl',
      fixedWrapper: '.fixed-container',
      carousel: '.shop-the-look-carousel',
      arrows: '.slick-arrow',
      wrapperPins: '.js-wrapper-pins',
      pins: '.js-pin',
      backgroundImage: '.background-image-wrapper img'
    }
  }

  get CLASSES() {
    return {
      active: 'active'
    }
  }

  constructor() {
    super();

    this.carousel = $(this.SELECTORS.carousel);
    this.controller = new ScrollMagic.Controller();
    this.containers = $(this.SELECTORS.container);
    this.backdropMobile = $(this.SELECTORS.backdropMobile);
    this.pins = $(this.SELECTORS.pins);
    this.isClick = false;
    this.scene;
    this.timeout;
    this.timeout2;
  }

  toPercent(pxScrolled, pxScrollable) {
    return (pxScrolled * 100) / pxScrollable;
  }

  closestPin(scrolled, pins) {
    return pins.reduce(function (prev, curr) {
      return (Math.abs(curr - scrolled) < Math.abs(prev - scrolled) ? curr : prev);
    });
  }

  nextPin(varPins, percentScrolled) {
    let nextPins = [];
    varPins.forEach((element, index) => {
      element > percentScrolled ? nextPins.push(element) : '';
    });
    return nextPins[0];
  }

  bindScroll(element, varPins, closestPin) {
    let $el = $(element),
      scrollable = $(this.SELECTORS.wrapperPins).height(),
      elHeight = $el.height(),
      elOffset = $el.offset().top,
      scrolled = document.documentElement.scrollTop;

    if (scrolled >= elOffset && scrolled <= (elOffset + elHeight - document.documentElement.clientHeight)) {
      let insideScrolled = scrolled - elOffset;
      let percentScrolled = this.toPercent(insideScrolled, scrollable);

      if (closestPin != this.closestPin(percentScrolled, varPins)) {
        closestPin = this.closestPin(percentScrolled, varPins);
        let goTo = varPins.indexOf(closestPin);
        console.log('vado alla slide {}', goTo);
        this.carousel.slick('slickGoTo', goTo);
      }
    }
  }


  handleScrollInElement(element) {
    let _this = this,
      $el = $(element),
      scrollable = $(this.SELECTORS.wrapperPins).height(),
      elHeight = $el.height(),
      elOffset = $el.offset().top;

    if (this.pins.length) {
      let varPins = [];

      this.pins.each((index, element) => {
        varPins.push(Number(element.style.top.slice(0, -1)));
      })

      // riordino l'array
      varPins.sort((a, b) => {
        return a - b;
      })

      let closestPin = varPins[0];

      $(window).on('scroll.stl-component', () => {
        // _this.bindScroll(element, varPins, closestPin);
        let scrolled = document.documentElement.scrollTop;

        if (scrolled >= elOffset && scrolled <= (elOffset + elHeight - document.documentElement.clientHeight)) {
          let insideScrolled = scrolled - elOffset;
          let percentScrolled = _this.toPercent(insideScrolled, scrollable);

          if (closestPin != _this.closestPin(percentScrolled, varPins)) {
            closestPin = _this.closestPin(percentScrolled, varPins);
            let goTo = varPins.indexOf(closestPin);
            // TODO festire meglio il goTo slide
            _this.carousel.slick('slickGoTo', goTo);
          }
        }
      });

      _this.carousel.find(_this.SELECTORS.arrows).on('click.stl-carousel', () => {
        _this.isClick = true;
      });

      _this.carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        setTimeout(() => {
          if (_this.isClick) {
            $('html, body').animate({
              scrollTop: $(`.wrapper-pins div:nth-child(${nextSlide + 1})`).offset().top - document.documentElement.clientHeight / 2
            }, 1000);
            _this.isClick = false;
          }
        }, 100);
      });
    }
  }

  init(container) {
    let $container = $(container),
        image = $container.find(this.SELECTORS.backgroundImage);

    image.on("load", () => {
      let fixedWrapper = $container.find(this.SELECTORS.fixedWrapper),
          offsetStart = document.documentElement.clientHeight / 2,
          duration = $container.height() - (offsetStart * 2);

      // prevent scrollmagic error
      if (duration < 0) duration = 1;
  
      this.scene = new ScrollMagic.Scene({
          triggerElement: container,
          offset: offsetStart,
          duration: duration
        })
        .setPin(fixedWrapper[0])
        // .addIndicators()
        .addTo(this.controller);
  
      this.handleScrollInElement(container);
    }).each((index, element) => {

        // trigger event when image is cached
        if(element.complete) {
          $(element).trigger('load');

      }
    });
  }

  mobileEvents(container) {
    container.addEventListener('touchstart', handleTouchStart);
    container.addEventListener('touchend', handleTouchEnd);

    let _this = this,
      xDown = null,
      yDown = null;

    function handleTouchStart(evt) {
      const firstTouch = evt.changedTouches[0];
      xDown = firstTouch.clientX;
      yDown = firstTouch.clientY;
    };

    function handleTouchEnd(evt) {
      if (!xDown || !yDown) {
        return;
      }

      var xUp = evt.changedTouches[0].clientX;
      var yUp = evt.changedTouches[0].clientY;

      var xDiff = xDown - xUp;
      var yDiff = yDown - yUp;

      if (xDiff > 20) {
        $(_this.backdropMobile).addClass('visible');
        $(container).addClass('swiped');
      }

      /* reset values */
      xDown = null;
      yDown = null;
    };

    // MR3-573
    $(container).find(this.SELECTORS.carousel).click((e) => {
      if(!$(container).hasClass('swiped')){
        e.preventDefault();
        $(_this.backdropMobile).addClass('visible');
        $(container).addClass('swiped');
      }
    });
  }

  bindEvents(container) {
    let _this = this;

    _this.carousel.on('init', function (event, slick) {
      _this.log("Shop the look initialized");
      if (_this.$matchMedia('md', null)) {
        _this.mobileEvents(container);
      } else {
        _this.init(container);
      }
    });

    window.addEventListener('resize', () => {

      _this.log("Shop the look re-initialized");
      // eseguo l'unbind degli eventi
      if (_this.scene != undefined) _this.scene.destroy(true);
      _this.carousel.find(_this.SELECTORS.arrows).off('click.stl-carousel');
      _this.carousel.off('beforeChange');
      $(window).off('scroll.stl-component');
      // reinizializzo il componente

      if (_this.$matchMedia('md', null)) {
        $(_this.backdropMobile).removeClass('visible');
        $(container).removeClass('swiped');
        // _this.log('sono sotto md');
        _this.mobileEvents(container);
      } else {
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(() => {
          _this.init(container);
        }, 200);
      }

    });

  }

  render() {

    if (this.containers.length) {
      this.containers.each((index, element) => {
        if (!$(element).hasClass('is-edit')) this.bindEvents(element);
      })
    }

  }
}
